import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import Tools from 'routes/Products/components/Tools';

class ToolsPage extends PureComponent {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return <Tools {...this.props} />;
  }
}

ToolsPage.propTypes = {
  id: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  Children: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  data: PropTypes.shape({}).isRequired
};

export default ToolsPage;
